
(function() {
  var result = { translations: { "ko": { "i18n": { "duration": { "seconds": "{{ seconds }}\uCD08", "minutes": "{{ minutes }}\uBD84", "hours": "{{ hours }}\uC2DC\uAC04", "hoursAndMinutes": "{{ hours }}\uC2DC\uAC04 {{ minutes }}\uBD84", "days": "{{ days }}\uC77C", "shortForm": { "seconds": "{{ seconds }}\uCD08", "minutes": "{{ minutes }}\uBD84", "hours": "{{ hours }}\uC2DC\uAC04", "days": "{{ days }}\uC77C", "hoursAndMinutes": "{{ hours }}\uC2DC\uAC04 {{ minutes }}\uBD84" } }, "dateTime": { "quarterAndYear": "{{yearNumber}} {{quarterNumber}}\uBD84\uAE30" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}}{{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, \uB0B4\uC120\uBC88\uD638: {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "ko": "static-7.1029"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1029",
    "ar-eg": "static-7.1029",
    "bg": "static-7.1029",
    "bn": "static-7.1029",
    "ca-es": "static-7.1029",
    "cs": "static-7.1029",
    "da": "static-7.1029",
    "de": "static-7.1029",
    "el": "static-7.1029",
    "en-gb": "static-7.1029",
    "en": "static-7.1029",
    "es-mx": "static-7.1029",
    "es": "static-7.1029",
    "et": "static-7.1029",
    "fi": "static-7.1029",
    "fr-ca": "static-7.1029",
    "fr": "static-7.1029",
    "he-il": "static-7.1029",
    "hi": "static-7.1029",
    "hr": "static-7.1029",
    "hu": "static-7.1029",
    "id": "static-7.1029",
    "it": "static-7.1029",
    "ja": "static-7.1029",
    "ko": "static-7.1029",
    "lt": "static-7.1029",
    "ms": "static-7.1029",
    "nl": "static-7.1029",
    "no": "static-7.1029",
    "pl": "static-7.1029",
    "pt-br": "static-7.1029",
    "pt-pt": "static-7.1029",
    "ro": "static-7.1029",
    "ru": "static-7.1029",
    "sk": "static-7.1029",
    "sl": "static-7.1029",
    "sv": "static-7.1029",
    "th": "static-7.1029",
    "tl": "static-7.1029",
    "tr": "static-7.1029",
    "uk": "static-7.1029",
    "vi": "static-7.1029",
    "x-pseudo": "static-7.1029",
    "zh-cn": "static-7.1029",
    "zh-hk": "static-7.1029",
    "zh-tw": "static-7.1029"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:ko', {version: 'static-7.1029'}); }
})();


